import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const ReferencesPage = lazy(() =>
  import("@/admin/pages/ReferencesPage").then((m) => ({ default: m.ReferencesPage })),
);

export const Route = createFileRoute("/admin/references")({
  component: () => (
    <Suspense fallback={null}>
      <ReferencesPage />
    </Suspense>
  ),
});
